import React from 'react';
import { Select } from 'formik-material-ui';
import useTheme from '@material-ui/core/styles/useTheme';
import { makeStyles, Typography } from '@material-ui/core';
import { styleBreakDesktop } from './utilities/layouts/Globals';
import MenuItem from '@material-ui/core/MenuItem';
import { Field } from 'formik';
import FormControl from '@material-ui/core/FormControl';
import clsx from 'clsx';
import { getStyle, mergeStyles } from '../styles/stylesSelector';
import { cloneDeep } from 'lodash';
import { COLOR_GREY, FONT_WEIGHT_SEMI } from './utilities/Material';
import { ReactComponent as SelectIcon } from '../resources/images/chevron-right.svg';

const useStyles = makeStyles(theme => {
    const styles = {
        healthCardSystemDropDownSelect: {
            width: '100%',
            [styleBreakDesktop(theme)]: {
                width: theme.spacing(41),
            },
        },
        span: {
            fontWeight: '500',
        },
        selectIcon: {
            transform: 'rotate(90deg)',
            width: '20px',
            height: '20px',
            top: 'auto',
            strokeWidth: '2px',
        },
    };

    let nedStyles = {
        italize: {
            fontStyle: 'italic',
        },
        span: {
            color: '#212121',
        },
        monthSelector: {
            width: '100%',
            '& fieldset': {
                borderColor: '#979797',
            },
        },
        healthCardSystemSelectorField: {
            '& fieldset': {
                borderColor: '#979797',
            },
        },
        selectIcon: {
            color: '#747B84',
        },
        paperStyle: {
            maxHeight: theme.spacing(18),
        },
    };
    nedStyles = mergeStyles(cloneDeep(styles), nedStyles);

    let watchmanStyles = {
        span: {
            color: theme.palette.primary.dark,
        },
        monthSelector: {
            width: '100%',
            '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                    borderWidth: '1px',
                },
            },
            '& fieldset': {
                border: `1px solid ${COLOR_GREY.light}`,
            },
        },
        monthSelectorFilled: {
            '& fieldset': {
                border: `1px solid ${theme.palette.primary.dark}`,
            },
        },
        monthSelectorInvalid: {
            '& fieldset': {
                border: `1px solid ${theme.palette.error.main}`,
            },
        },
        spanInactive: {
            color: COLOR_GREY.light,
            fontWeight: FONT_WEIGHT_SEMI,
        },
        paperStyle: {
            maxHeight: theme.spacing(41.25),
        },
        selectIconUnselected: {
            color: COLOR_GREY.light,
        },
        selectIconSelected: {
            color: theme.palette.primary.dark,
        },
        menuItem: {
            '&.MuiListItem-root.Mui-selected': {
                backgroundColor: theme.palette.primary.light,
            },
        },
    };
    watchmanStyles = mergeStyles(cloneDeep(styles), watchmanStyles);

    return getStyle({
        ned: nedStyles,
        watchman: watchmanStyles,
    });
});

const Span = props => {
    const classes = useStyles();

    return <Typography component="span" className={classes.span} {...props} />;
};

const StyledSelect = ({ dropDownBelowSelect, isinvalid, filled, ...props }) => {
    const classes = useStyles();

    const menuProps = {
        classes: { paper: classes.paperStyle },
    };

    if (dropDownBelowSelect) {
        menuProps.anchorOrigin = {
            vertical: 'bottom',
            horizontal: 'left',
        };
        menuProps.getContentAnchorEl = null;
    }
    return (
        <Select
            MenuProps={menuProps}
            IconComponent={SelectIcon}
            classes={{
                icon: clsx(classes.selectIcon, { [classes.selectIconUnselected]: !filled }, { [classes.selectIconSelected]: filled }),
            }}
            {...props}
        />
    );
};

export const MonthSelectorField = props => {
    const theme = useTheme();
    const classes = useStyles();

    return (
        <FormControl
            variant="outlined"
            className={clsx(classes.monthSelector, { [classes.monthSelectorFilled]: props.filled }, { [classes.monthSelectorInvalid]: !!props.isinvalid })}
        >
            <Field component={StyledSelect} theme={theme} {...props} required displayEmpty={true} dropDownBelowSelect={true}>
                <MenuItem value="" disabled={true} key="month_heading">
                    <Typography className={clsx(classes.italize, classes.spanInactive)}>Month</Typography>
                </MenuItem>
                <MenuItem value="0" key="month0" classes={{ root: classes.menuItem }}>
                    <Span>January</Span>
                </MenuItem>
                <MenuItem value="1" key="month1" classes={{ root: classes.menuItem }}>
                    <Span>February</Span>
                </MenuItem>
                <MenuItem value="2" key="month2" classes={{ root: classes.menuItem }}>
                    <Span>March</Span>
                </MenuItem>
                <MenuItem value="3" key="month3" classes={{ root: classes.menuItem }}>
                    <Span>April</Span>
                </MenuItem>
                <MenuItem value="4" key="month4" classes={{ root: classes.menuItem }}>
                    <Span>May</Span>
                </MenuItem>
                <MenuItem value="5" key="month5" classes={{ root: classes.menuItem }}>
                    <Span>June</Span>
                </MenuItem>
                <MenuItem value="6" key="month6" classes={{ root: classes.menuItem }}>
                    <Span>July</Span>
                </MenuItem>
                <MenuItem value="7" key="month7" classes={{ root: classes.menuItem }}>
                    <Span>August</Span>
                </MenuItem>
                <MenuItem value="8" key="month8" classes={{ root: classes.menuItem }}>
                    <Span>September</Span>
                </MenuItem>
                <MenuItem value="9" key="month9" classes={{ root: classes.menuItem }}>
                    <Span>October</Span>
                </MenuItem>
                <MenuItem value="10" key="month10" classes={{ root: classes.menuItem }}>
                    <Span>November</Span>
                </MenuItem>
                <MenuItem value="11" key="month11" classes={{ root: classes.menuItem }}>
                    <Span>December</Span>
                </MenuItem>
            </Field>
        </FormControl>
    );
};

export const HealthCardSystemSelectorField = props => {
    const theme = useTheme();
    const classes = useStyles();

    return (
        <FormControl variant="outlined" fullWidth={true} className={classes.healthCardSystemSelectorField}>
            <Field
                component={StyledSelect}
                className={classes.healthCardSystemDropDownSelect}
                theme={theme}
                {...props}
                dropDownBelowSelect={true}
                required
                displayEmpty={true}
            >
                <MenuItem value="" disabled={true} key="province_title">
                    <Typography component={Span} className={classes.italize}>
                        Select a province
                    </Typography>
                </MenuItem>
                <MenuItem value={HealthCardSystem.ONTARIO} key="ontario">
                    <Span>Ontario</Span>
                </MenuItem>
                <MenuItem value={HealthCardSystem.ALBERTA} key="alberta">
                    <Span>Alberta</Span>
                </MenuItem>
                <MenuItem value={HealthCardSystem.NOVA_SCOTIA} key="nova_scotia">
                    <Span> Nova Scotia</Span>
                </MenuItem>
            </Field>
        </FormControl>
    );
};

export const HealthCardSystem = {
    ALBERTA: 'ALBERTA',
    NOVA_SCOTIA: 'NOVA_SCOTIA',
    ONTARIO: 'ONTARIO',
};
